import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Divider, Grid, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MuiInputField from "../../../Components/InputField/InputField";
import MultiCheckBoxes from "../../../Components/MultiCheckBox/MultiCheckBoxes";
import AddButton from "../../../Components/AddButton/AddButton";
import MultiSelectDropDown from "../../../Components/DropDown/MultiSelectDropDown";
import List from "@mui/material/List";

function PopUpButtons(props) {
  return (
    <Button>
      <Box
        onClick={props.onClick}
        sx={{
          padding: "10px 30px",
          borderRadius: "6px",
          border: "none",
          backgroundColor: props.btnColor,
          textTransform: "capitalize",
        }}
      >
        <Typography
          sx={{
            color: "white",
          }}
        >
          {props.btnName}
        </Typography>
      </Box>
    </Button>
  );
}

function CategoryAdd(props) {
  return (
    <Box
      sx={{
        ...props.style,
        width: 600,
        border: "1px solid lightgray",
        minHeight: 400,
        borderRadius: "15px",
        outline: "none",
        padding: "15px",
        // bgcolor: "red",
      }}
    >
      <Grid container justifyContent="space-between" alignItems={"center"} >
        <Grid container width={"100%"} alignItems={"center"}>
          <Typography
            color={"#2E2E2E"}
            sx={{
              fontWeight: "bold",
              flex: 1,
              paddingTop: "18px",
              paddingLeft: "24px",
            }}
          >
            New Category
          </Typography>
          <MultiCheckBoxes
            setCheckedItems={props.setCheckedItems}
            setCheckedItemsId={props.setCheckedItemsId}
            checkedItems={props.checkedItems}
            items={props.items}
          />
          <Box
            onClick={() =>
              props.setOpenModal({
                isOpen: false,
              })
            }
            sx={{
              width: 25,
              height: 25,
              backgroundColor: "#adbdd6",
              borderRadius: "100px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "10px",
              marginTop: "10px",
              cursor: "pointer",
            }}
          >
            <CloseIcon
              sx={{
                width: 15,
                color: "white",
              }}
              onClick={() => {
                props.setaddSpecialitiesList("");
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid paddingY={1}>
        <Divider />
      </Grid>
      <Grid paddingX={3} paddingY={1}>
        <Typography color={"#2E2E2E"} paddingBottom={1} fontWeight={600}>
          Add Category
        </Typography>
        <MuiInputField
          type="text"
          value={props.category}
          onChange={(event) => {
            props.setCategory(event.target.value);
          }}
          placeHolder={"Add new Category"}
        />
      </Grid>
      {/* Add Specialities */}
      <Grid paddingX={5} paddingY={2}>
        <Typography color={"#2E2E2E"} paddingBottom={1} fontWeight={600}>
          Add Specialities
        </Typography>
        <MuiInputField
          type="text"
          value={props.addSpecialities}
          onChange={(event) => {
            props.setaddSpecialities(event.target.value);
          }}
          placeHolder={"Add new Category"}
        />
        {/* Add new specialitiy btn */}

        <Grid paddingY={2}>
          <Typography>
            {Array.isArray(props.addSpecialitiesList) &&
              props.addSpecialitiesList.map((speciality, index) => (
                <List key={index}>
                  <Typography>{speciality}</Typography>
                </List>
              ))}
          </Typography>
          <AddButton
            labelName={"Add new specialitiy"}
            onClick={() => {
              const newSpeciality = props.addSpecialities;
              if (newSpeciality.trim() !== "") {
                props.setaddSpecialitiesList((prevList) => [
                  ...prevList,
                  newSpeciality,
                ]);
                props.setaddSpecialities("");
              }
            }}
            width={"40%"}
            viewHeight={"40px"}
            borderRadius={"10px"}
          />
        </Grid>
      </Grid>

      <Grid
        container
        item
        lg={12}
        height={"80px"}
        justifyContent="flex-end"
        alignItems={"center"}
        sx={{
          gap: "5px",
        }}
      >
        <PopUpButtons
          btnName="Cancel"
          btnColor="grey"
          onClick={() => {
            props.setOpenModal({
              isOpen: false,
            });
            props.setaddSpecialitiesList("");
          }}
        ></PopUpButtons>
        {props?.departmentId && (
          <PopUpButtons
            btnName="Delete"
            btnColor={"red"}
            onClick={() => {
              props.onDelete();
              props.setOpenModal({
                isOpen: false,
              });
            }}
          ></PopUpButtons>
        )}
        <PopUpButtons
          btnName="Save"
          btnColor="#17dfba"
          onClick={() => {
            props.onSave();
          }}
        ></PopUpButtons>
      </Grid>
    </Box>
  );
}
function AddNewTreatment(props) {
  return (
    <Box
      sx={{
        ...props.style,
        width: 600,
        border: "1px solid lightgray",
        height: 420,
        borderRadius: "15px",
        outline: "none",
        padding: "15px",
      }}
    >
      <Grid
        container
        justifyContent="space-between"
        paddingLeft={3}
        alignItems={"center"}
      >
        <Grid>
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            Add new Treatment
          </Typography>
        </Grid>
        <Box
          onClick={() =>
            props.setOpenModal({
              isOpen: false,
            })
          }
          sx={{
            width: 25,
            height: 25,
            backgroundColor: "#adbdd6",
            borderRadius: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: "10px",
            marginTop: "10px",
            cursor: "pointer",
          }}
        >
          <CloseIcon
            sx={{
              width: 15,
              color: "white",
            }}
            // onClick={console.log("hai")}
          />
        </Box>
      </Grid>
      <Grid paddingY={1}>
        <Divider />
      </Grid>
      <Grid paddingX={3} paddingY={1}>
        <MuiInputField
          type="text"
          value={props.category}
          onChange={(event) => {
            props.setCategory(event.target.value);
          }}
          placeHolder={"Add New Treatment"}
        />
      </Grid>

      <Grid paddingX={3} paddingY={2}>
        <Typography paddingBottom={1} fontWeight={600}>
          Tag Specialities (Optional)
        </Typography>
        <MultiSelectDropDown
          placeHolder={"Consumables"}
          viewHeight={"44px"}
          borderRadius={"5px"}
          bgColor="white"
          border="2px solid #e9eff7"
          viewWidth="100%"
          handleSelected={(event, value) => {
            props?.setspecialitiesDataId((s) => ({
              ...s,
              selectedSpecialities: value.map((val) => val.id),
            }));
          }}
          placeholder="Choose Specialisation"
          data={props?.specialitiesData}
          value={props?.specialitiesDataId}
        />
      </Grid>
      <Grid paddingX={3} container justifyContent="space-between" item lg={12}>
        <Grid item lg={5}>
          <Typography paddingY={1} fontWeight={600}>
            Cash Min.Price
          </Typography>
          <MuiInputField
            type="number"
            value={props.minFee}
            onChange={(event) => {
              props.setMinFee(event.target.value);
            }}
            placeHolder={"Add price"}
          />
        </Grid>
        <Grid item lg={5}>
          <Typography paddingY={1} fontWeight={600}>
            EMI Min.Price
          </Typography>
          <MuiInputField
            type="number"
            value={props.maxFee}
            onChange={(event) => {
              props.setMaxFee(event.target.value);
            }}
            placeHolder={"Add price"}
          />
        </Grid>
      </Grid>
      <Grid paddingX={3}>
        <MultiCheckBoxes
          setCheckedItems={props.setCheckedItems}
          setCheckedItemsId={props.setCheckedItemsId}
          checkedItems={props.checkedItems}
          items={props.items}
        />
      </Grid>
      <Grid
        container
        item
        lg={12}
        height={"80px"}
        justifyContent="flex-end"
        alignItems={"center"}
        sx={{
          gap: "5px",
        }}
      >
        {props.buttons.map((item) => {
          return (
            <Button>
              <Box
                // onClick={console.log(
                //   "========================hhhhhhhhhhhhhhhhh"
                // )}
                onClick={() => {
                  if (item.buttonName === "Cancel") {
                    props.setOpenModal({
                      isOpen: false,
                    });
                  } else if (item.buttonName == "Save") {
                    console.log("===========================jjjjjjjjjjjjjj");
                    props.onSave();
                  }
                }}
                sx={{
                  padding: "10px 30px",
                  borderRadius: "10px",
                  border: "none",
                  backgroundColor:
                    item.buttonName == "Save" ? "#17DFBA" : "#4C5A6A",
                  textTransform: "capitalize",
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                  }}
                >
                  {item.buttonName}
                </Typography>
              </Box>
            </Button>
          );
        })}
      </Grid>
    </Box>
  );
}

function AlertPopUp(props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  return (
    <Box
      sx={{
        ...style,
        width: 400,
        border: "1px solid lightgray",
        height: 200,
        borderRadius: "15px",
        outline: "none",
        padding: 0,
      }}
    >
      <Grid container justifyContent="flex-end" alignItems={"center"}>
        <Box
          onClick={() =>
            props.setOpenModal({
              isOpen: false,
            })
          }
          sx={{
            width: 20,
            height: 20,
            backgroundColor: "#adbdd6",
            borderRadius: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: "10px",
            marginTop: "10px",
            cursor: "pointer",
          }}
        >
          <CloseIcon
            sx={{
              width: 15,
              color: "white",
            }}
          />
        </Box>
      </Grid>
      <Grid>
        <Typography sx={{ textAlign: "center", fontWeight: "bold" }}>
          {props?.headText}
        </Typography>
      </Grid>
      <Grid
        container
        item
        lg={11.5}
        height={"90px"}
        justifyContent="center"
        alignItems={"center"}
        sx={{ gap: "5px" }}
      >
        {props?.data.buttons.map((item) => {
          return (
            <Button>
              <Box
                onClick={() => {
                  if (item.buttonName === "No") {
                    props?.setOpenModal({ isOpen: false });
                  } else if (item.buttonName == "Yes") {
                    props.handleYes();
                  }
                }}
                sx={{
                  padding: "10px 30px",
                  borderRadius: "6px",
                  border: item.buttonName === "No" ? "1px solid black" : "none",
                  backgroundColor:
                    item.buttonName === "No"
                      ? "#fff"
                      : props.warning
                      ? "red"
                      : "#17dfba",
                  textTransform: "capitalize",
                }}
              >
                <Typography
                  sx={{
                    color: item.buttonName === "No" ? "#000" : "white",
                  }}
                >
                  {item.buttonName}
                </Typography>
              </Box>
            </Button>
          );
        })}
      </Grid>
    </Box>
  );
}

export default function TreatmentPopUp({
  setOpenModal,
  openModal,
  data,
  specialitiesData,
  departmentId,
  treatments,
}) {
  console.log("============================================data==", data);
  const handleOpen = () => {
    setOpenModal({ isOpen: true });
  };
  const handleClose = () => {
    setOpenModal({ isOpen: false });
  };
  console.log(specialitiesData, "==========");
  const [checkedItems, setCheckedItems] = React.useState({});
  const [checkedItemsId, setCheckedItemsId] = React.useState([]);
  const [specialitiesDataId, setspecialitiesDataId] = React.useState([]);
  const [category, setCategory] = React.useState("");
  const [addSpecialities, setaddSpecialities] = React.useState("");
  const [addSpecialitiesList, setaddSpecialitiesList] = React.useState("");
  const [treatmentName, setTreatmentName] = React.useState("");
  const [minFee, setMinFee] = React.useState("");
  const [maxFee, setMaxFee] = React.useState("");

  // console.log(specialitiesDataId, "state update=======");
  console.log(addSpecialitiesList, "checking===");

  React.useEffect(() => {
    if (data?.data?.categoryValue && data?.data?.departmentId) {
      const categoryData = data?.data?.categoryValue;
      setCategory(categoryData.name);
      const matchingData = categoryData.platforms?.map((item) => {
        setCheckedItems((prevCheckedItems) => ({
          ...prevCheckedItems,
          [item.id]: true,
        }));
      });
      const ids = categoryData.platforms?.map((item) => item.id);
      setCheckedItemsId(ids);
    } else if (data?.data?.treatmentValue && data?.data?.treatmentId) {
      const treatmentData = data?.data?.treatmentValue;
      setTreatmentName(treatmentData.name);
      setMaxFee(treatmentData.emiMinPrice);
      setMinFee(treatmentData.cashMinPrice);
      const matchingData = treatmentData.platforms?.map((item) => {
        setCheckedItems((prevCheckedItems) => ({
          ...prevCheckedItems,
          [item.id]: true,
        }));
      });
      const ids = treatmentData.platforms?.map((item) => item.id);
      setCheckedItemsId(ids);
    } else {
      setCheckedItemsId([]);
      setCheckedItems([]);
      setMaxFee("");
      setMinFee("");
      setCategory("");
      setTreatmentName("");
    }
  }, [data]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const items = [
    { id: 1, name: "Mykare" },
    { id: 2, name: "KareTrip" },
    { id: 3, name: "Karemitra" },
    // { id: 3, name: "Partner App" },
  ];

  const buttons = [
    { id: 1, buttonName: "Cancel" },
    { id: 2, buttonName: "Save" },
  ];

  return (
    <div style={{ display: "none" }}>
      <Button onClick={handleOpen}>Open modal</Button>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        {data?.data?.type == "CATEGORY" ? (
          <CategoryAdd
            setOpenModal={setOpenModal}
            checkedItems={checkedItems}
            setCheckedItems={setCheckedItems}
            setCheckedItemsId={setCheckedItemsId}
            category={category}
            setCategory={setCategory}
            style={style}
            items={items}
            buttons={buttons}
            departmentId={data?.data?.departmentId}
            addSpecialities={addSpecialities}
            setaddSpecialities={setaddSpecialities}
            setaddSpecialitiesList={setaddSpecialitiesList}
            addSpecialitiesList={addSpecialitiesList}
            onSave={() => {
              if (category && checkedItemsId.length) {
                data?.data?.save(
                  {
                    name: category,
                    platformIds: checkedItemsId.map((val) => Number(val)),
                    specialization: addSpecialitiesList
                      ? addSpecialitiesList
                      : [""],
                  },

                  data?.data?.departmentId
                );
                setOpenModal({
                  isOpen: false,
                });
                setaddSpecialitiesList("");
              } else {
                alert("All fields are required");
              }
            }}
            onDelete={() => {
              data?.data?.delete(data?.data?.departmentId);
            }}
          ></CategoryAdd>
        ) : data?.data?.type == "TREATMENT" ? (
          <AddNewTreatment
            setOpenModal={setOpenModal}
            checkedItems={checkedItems}
            setCheckedItems={setCheckedItems}
            setCheckedItemsId={setCheckedItemsId}
            category={treatmentName}
            setCategory={setTreatmentName}
            minFee={minFee}
            setMinFee={setMinFee}
            maxFee={maxFee}
            setMaxFee={setMaxFee}
            style={style}
            items={items}
            buttons={buttons}
            specialitiesData={specialitiesData}
            setspecialitiesDataId={setspecialitiesDataId}
            onSave={() => {
              if (minFee && departmentId && maxFee && checkedItemsId.length) {
                data?.data?.save(
                  {
                    cashMinPrice: minFee,
                    departmentId: departmentId,
                    emiMinPrice: maxFee,
                    name: treatmentName,
                    platformIds: checkedItemsId.map((val) => Number(val)),
                    specialityIds:
                      specialitiesDataId?.selectedSpecialities?.map((data) =>
                        Number(data)
                      ) || [],
                  },
                  data?.data?.treatmentId
                );
                setOpenModal({
                  isOpen: false,
                });
              } else {
                alert("All fields are required");
              }
            }}
          />
        ) : data?.data?.type == "DELETE" || data?.data?.type == "APPROVE" ? (
          <AlertPopUp
            headText={
              data?.data?.type == "DELETE"
                ? "Are you sure want to delete?"
                : data?.data?.type == "FLAG"
                ? "Are you sure want to Flag?"
                : data?.data?.checked
                ? "Are you sure want to un approve?"
                : "Are you sure want to approve"
            }
            setOpenModal={setOpenModal}
            handleYes={() => {
              if (data?.data?.type == "DELETE") {
                data?.data?.deleteData(data?.data?.deletedId);
                setOpenModal({ isOpen: false });
              } else {
                console.log(data?.data?.approve, "approve");
                data?.data?.handleApprove({
                  approved: data?.data?.approve,
                  departmentId: data?.data?.id,
                });
                setOpenModal({ isOpen: false });
              }
            }}
            warning={data?.data?.type == "DELETE"}
            data={data.data}
          />
        ) : (
          <></>
        )}
      </Modal>
    </div>
  );
}
